import { createFileRoute, redirect } from '@tanstack/react-router'
import { AccountingTaxCentreScreen } from '@/features/accounting-tax/tax-centre-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/tax')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_tax.edit')) {
      throw redirect({ to: '/accounting' })
    }
  },
  component: AccountingTaxCentreScreen,
})
